import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftoutlookComponent } from './simple-icons-microsoftoutlook.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftoutlookComponent ],
    exports:      [ SimpleIconsMicrosoftoutlookComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftoutlookModule {}
